import { render } from "./DashboardStatistic.vue?vue&type=template&id=21ca6790"
import script from "./DashboardStatistic.vue?vue&type=script&lang=js"
export * from "./DashboardStatistic.vue?vue&type=script&lang=js"

import "@/styles/profile/dashboard/dashboard.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__